// Interruttore centrale della pubblicità: "off" | "sponsor" | "adsense"
export const ADS_MODE = "off";

// Da compilare quando Google approva il sito (es. "ca-pub-1234567890123456")
export const ADSENSE_CLIENT_ID = "ca-pub-2387663447151314";

// Uno slot ID AdSense per ogni posizione
export const ADSENSE_SLOTS = {
  home: "",
  list: "",
  detail: "",
};

// Ogni quanti bisogni inserire un annuncio nella lista
export const ADS_LIST_EVERY = 8;
